import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-homepage-uk-whyflu',
  standalone: false,
  templateUrl: './homepage-uk-whyflu.component.html',
  styleUrl: './homepage-uk-whyflu.component.scss',
})
export class HomepageUkWhyfluComponent {

  private readonly iconMap: Record<string, string> = {
    'contact icon logo'    : '/assets/images/contactIcon.png',
    'Hospital logo'        : '/assets/images/hospIcon.png',
    'Truck logo'           : '/assets/images/truckIcon.png',
    'Clock logo'           : '/assets/images/clockIcon.png',
    'Financial tools logo' : '/assets/images/upgraphIcon.png',
    'Syringe logo'         : '/assets/images/syringeIcon.png',
  };

  publicnode$: Observable<any> = this.bannerComponent.data$;
  /*For We focus section start */
  broughtybData: Observable<any> = this.cmsService.getComponentData('seqirus-homepage-focus-Component');
    showFocusSection$: Observable<boolean> = this.publicnode$.pipe(
    map(item => item?.uid === 'SeqirusWhyFluDetailComponent')
    );
  getImage(image: any): string {
    if (image?.url) return this.config.backend?.occ?.baseUrl + image.url;
    if (image?.desktop?.url) return this.config.backend?.occ?.baseUrl + image.desktop.url;
    return '';
  }
  /*we focus section END  */

  content1$: Observable<SafeHtml> = this.publicnode$.pipe(
    map(item => this.patchIconSrc(item?.largeparagraphcontent1 ?? ''))
  );

  content2$: Observable<SafeHtml> = this.publicnode$.pipe(
    map(item => this.patchIconSrc(item?.largeparagraphcontent ?? ''))
  );

  constructor(
    public bannerComponent: CmsComponentData<CmsBannerComponent>,
    protected config: OccConfig,
    private cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private cmsService: CmsService
  ) {}

  private patchIconSrc(html: string): SafeHtml {
    if (!html) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    doc.querySelectorAll('img').forEach((img: HTMLImageElement) => {
      const alt = img.getAttribute('alt')?.trim() ?? '';
      const mappedSrc = this.iconMap[alt];
      if (mappedSrc) {
        img.setAttribute('src', mappedSrc);
      }
    });

    const patched = doc.body.innerHTML;

    return this.sanitizer.bypassSecurityTrustHtml(patched);
  }
}